import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const MentionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding: 0 50px 50px;
  width: 100%;
  max-width: calc(100vw - 100px);
  min-width: 1130px;
  margin: 0 auto;

  @media (max-width: 1230px) {
    min-width: 1130px;
    max-width: 1130px;
    padding: 0 25px 50px;
    overflow-x: auto;
  }
`

export const MentionsTabsContainer = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid ${Tokens.ColorBorder};
  margin-bottom: 8px;
`

export const MentionsTab = styled.button<{ $active: boolean }>`
  padding: 10px 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  color: ${({ $active }) => ($active ? Tokens.ColorUIPrimary : Tokens.ColorTextSecondary)};
  border-bottom: 2px solid ${({ $active }) => ($active ? Tokens.ColorUIPrimary : 'transparent')};
  transition: all 0.2s ease;

  &:hover {
    color: ${Tokens.ColorUIPrimary};
  }
`

export const TagItem = styled.span`
  background-color: ${Tokens.ColorUIWarnLight};
  color: ${Tokens.ColorTextPrimary};
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

export const TagRemoveButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${Tokens.ColorUIDangerDim};
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  display: inline-flex;
  align-items: center;

  &:disabled {
    cursor: progress;
    opacity: 0.4;
  }
`

export const ThemesRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
`

export const DateContainer = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  color: ${Tokens.ColorTextSecondary};
  font-size: 14px;
  min-width: 95px;
`

export const ThemesGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex: 1;
`

export const ContentContainer = styled.div`
  display: block;
`

export const ContentText = styled.p`
  padding: 10px;
  padding-left: 0;
  text-align: justify;
`
